import { InsightsOverTimeBinDtoModelSelector } from '../../../models';

export const completedOrdersFragment = (selector: InsightsOverTimeBinDtoModelSelector) => selector.interval.value;
